import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { sendGlobalTrackingThunk } from '../../redux/core/thunks.js';
import { sendRegistrationBffRequest, } from './service/index.js';
import { trackFailedRequest } from '../../tracking/index.js';
import { navigateToThunk } from '../../redux/core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { isInTwoStepWrapper } from '../../tracking/constants.js';
import { trackEmailAttemptSuccessfulRequest } from '../../tracking/featureSpecific/emailAndPassword/index.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
import { authSuccessThunk } from '../../redux/core/authSuccess/authSuccessSlice.js';
export const initialRegistrationState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    password: {
        value: '',
        error: false,
        errorMessage: '',
    },
    isLoading: false,
    keepMeInformed: false,
    errorStatus: null,
    showRegistrationSuccessfulModal: false,
};
export const registrationThunk = createAsyncThunk('registration/registrationRequest', async (_, { rejectWithValue, dispatch, getState }) => {
    const state = getState();
    const email = state.forms.registration.email.value;
    const password = state.forms.registration.password.value;
    const consent = state.forms.registration.keepMeInformed;
    const { disableCvUpload, forceRedirect } = state.core.sourceData;
    const brandTrackingType = state.core.siteConfig.loginregistration.brandTrackingType;
    const { activeWrapper } = state.core.wrapperContext;
    dispatch(registrationSlice.actions.setErrorStatus(null));
    try {
        const registrationResponse = await sendRegistrationBffRequest({
            email,
            password,
            consent: { thirdPartyMarketingContentEmail: consent },
        });
        let trackingCustomPayload = {
            componentState: `consentThirdPartyMarketingContentEmail_${consent ? 'checked' : 'unchecked'}`,
            eventName: ['candidateLogin', 'candidateAccountCreation'],
        };
        if (brandTrackingType === 'continental') {
            trackingCustomPayload = {
                eventName: [
                    'candidateLogin',
                    'candidateAccountCreation',
                    'cvMadeSearchable',
                    'CandidateAccountConfirmation',
                ],
            };
        }
        dispatch(sendGlobalTrackingThunk(trackEmailAttemptSuccessfulRequest, trackingCustomPayload));
        if (registrationResponse && activeWrapper === 'page' && forceRedirect) {
            await dispatch(authSuccessThunk('email', 201));
            return;
        }
        if (registrationResponse &&
            (activeWrapper === 'modal' || activeWrapper === 'stepModal')) {
            if (disableCvUpload) {
                await dispatch(authSuccessThunk('email', 201));
                return;
            }
            if (isInTwoStepWrapper(activeWrapper)) {
                dispatch(setActiveView(FORM_TYPES.TWO_STEP_CV_UPLOAD));
            }
            dispatch(registrationSlice.actions.setShowRegistrationSuccessfulModal(true));
            await dispatch(authSuccessThunk('email', 201));
            return;
        }
        else if (registrationResponse) {
            dispatch(navigateToThunk(FORM_TYPES.REGISTRATION_SUCCESS));
            await dispatch(authSuccessThunk('email', 201));
            return;
        }
        return rejectWithValue(500);
    }
    catch (error) {
        dispatch(sendGlobalTrackingThunk(trackFailedRequest, {
            formFailedAttemptsErrors: 'registrationPasswordDoNotMatch',
        }));
        return rejectWithValue(error);
    }
});
export const registrationSlice = createSlice({
    name: 'registration',
    initialState: initialRegistrationState,
    reducers: {
        updateEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updatePassword: (state, actions) => {
            state.password.value = actions.payload;
        },
        setIsLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
        updatePasswordErrorMessage: (state, actions) => {
            state.password.errorMessage = actions.payload;
        },
        updatePasswordError: (state, actions) => {
            state.password.error = actions.payload;
        },
        clearRegistrationInputs: (state) => {
            state.email.error = false;
            state.email.errorMessage = '';
            state.password.error = false;
            state.password.errorMessage = '';
            state.errorStatus = null;
        },
        toggleKeepMeInformed: (state) => {
            state.keepMeInformed = !state.keepMeInformed;
        },
        setErrorStatus: (state, actions) => {
            state.errorStatus = actions.payload;
        },
        setShowRegistrationSuccessfulModal: (state, actions) => {
            state.showRegistrationSuccessfulModal = actions.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(registrationThunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(registrationThunk.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(registrationThunk.rejected, (state, { payload }) => {
            state.isLoading = false;
            state.errorStatus = payload;
        });
    },
});
export const { updateEmail, updatePassword, setIsLoading, updateEmailError, updatePasswordError, toggleKeepMeInformed, updateEmailErrorMessage, updatePasswordErrorMessage, clearRegistrationInputs, setShowRegistrationSuccessfulModal, setErrorStatus, } = registrationSlice.actions;
const registrationState = (state) => state.forms.registration;
export const emailSelector = createSelector(registrationState, (state) => state.email);
export const passwordSelector = createSelector(registrationState, ({ password }) => password);
export const isLoadingSelector = createSelector(registrationState, ({ isLoading }) => isLoading);
export const keepMeInformedSelector = createSelector(registrationState, ({ keepMeInformed }) => keepMeInformed);
export const errorStatusSelector = createSelector(registrationState, ({ errorStatus }) => errorStatus);
export const showRegistrationSuccessfulModalSelector = createSelector(registrationState, ({ showRegistrationSuccessfulModal }) => showRegistrationSuccessfulModal);
export default registrationSlice.reducer;
//# sourceMappingURL=registrationSlice.js.map